import iimjobsTheme from './themes/iimjobs';
import hiristTheme from './themes/hirist';

const theme = {
  iimjobs: iimjobsTheme,
  hirist: hiristTheme,
};

export default theme;
